import React from 'react';
import {Menu, Layout} from "antd";
import {
    BookOutlined,
    PoweroffOutlined,
    CalendarOutlined,
    PlayCircleOutlined
} from '@ant-design/icons';
import {useHistory, useLocation} from "react-router-dom";
import {connect} from "react-redux";
import {getUsername} from "./helpers/auth";

const Navbar = () => {
    const history = useHistory();
    const location = useLocation();

    const onClick = (item) => {
        if (item.key) {
            history.push(item.key);
        }
    }
    //console.log(this.props.settings.sidebar.collapsed);
    const parts = location.pathname.split('/');
    const root = '/' + parts[1];
    let current = '';
    for (let i = 1; i < parts.length; i++) {
        current += '/' + parts[i];
    }
    const items = [
        {label: <img className="logo" alt="logo" src="/img/logo.svg"/>, key: '/'},
        {label: 'Utwory', key: '/compositions', icon: <BookOutlined/>},
        {label: 'Kategorie', key: '/categories', icon: <BookOutlined/>},
        {label: 'Kalendarz', key: '/calendar', icon: <CalendarOutlined/>},
        {label: 'Ćwiczenia', key: '/exercises', icon: <PlayCircleOutlined/>},
        {label: 'Wyloguj ' + getUsername(), key: '/login', icon: <PoweroffOutlined/>, style: {marginLeft: 'auto'}},
    ];
    return <Layout className="layout">
        <Menu theme="dark"
              selectedKeys={[root, current]}
              mode="horizontal"
              items={items}
              onClick={onClick}>
        </Menu>

    </Layout>
}

const mapStateToProps = (state) => ({
    settings: state.Settings
});

export default connect(mapStateToProps, {})(Navbar);
